import React from 'react'
import { api } from '../../../../util/urlConfig';
import './commentreply.css'

function SupplierReply({ reply }) {
    const dateConverter = (date) => {
        let convertedDate = new Date(date).toISOString().slice(0, 10);
        return convertedDate
    }

    return (
        <div className='comment-container'>
            <div className="head-comment">
                <div className='title-area'>
                    <img src={reply.created_by.upload_image ? api + "/" + reply.created_by.upload_image.image_url : "/img/dummy_avatar.png"} alt="avatar" />
                    <h3>{reply.created_by.first_name + " " + reply.updated_by.last_name}</h3>
                </div>
                <p>{dateConverter(reply.created_at)}</p>
            </div>
            <div className="comment">
                <p>
                    {reply.note}
                </p>
            </div>
        </div>
    )
}

export default SupplierReply